import { customEvents } from './utils';

const initYoutubeEmbedDropdown = () => {
    customEvents.register(function (data) {
        if (data.target.classList.contains("is-open")) return;
        let ddToggler = data.target.querySelector(".js-dropdown-toggler")
        if (ddToggler) {
            ddToggler.click();
        }
    }, 'anchorScrollEnd');
}

export { initYoutubeEmbedDropdown }